/**
 * マーク選択画面のマークコードクラス
 *
 * @export MarkCodeInfo
 * @class MarkCodeInfo
 */
export class MarkCodeInfo {
    public check = false;
    constructor(public markCode: string, public markName: string) {}
}
  